import { Module } from "wrapper6";
import ObjectFitClass from "../utils/_object-fit";
import { scrollToAnchor } from "../utils/_scroll";

var $ = jQuery;

export default class FilterCars extends Module {
    ready(app) {
        const WRAPPERS = document.querySelectorAll('.cars-loop');
        if (WRAPPERS.length > 0) {
            for (let i = 0; i < WRAPPERS.length; i++) {
                new Filter(WRAPPERS[i]);
            }
        }
    }
}

class Filter {

    constructor(WRAPPER) {
        
        this.WRAPPER = WRAPPER;
        this.SCROLL_TO_ID = `#${this.WRAPPER.getAttribute('id')}`;
        this.CARS_WRAP = this.WRAPPER.querySelector('.cars-loop__wrap');
        this.PAGINATION_WRAP = this.WRAPPER.querySelector('.cars-loop__pagination');
        this.LOADER = this.WRAPPER.querySelector('.cars-loop__loader');

        this.data = {
            'action': 'filter_cars',
            'url': this.WRAPPER.getAttribute('data-main-url'),
            'type': this.WRAPPER.getAttribute('data-type'),
            'pagenumber': 1
        };

        this.initPagination();
        this.openDetails();
    }

    initPagination() {
        const LINKS = this.WRAPPER.querySelectorAll('.mtt-pagination__toggle');
        if (LINKS) {
            for (let i = 0; i < LINKS.length; i++) {
                const LINK = LINKS[i];
                LINK.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.data.pagenumber = LINK.getAttribute('data-page');
                    this.setUrl();
                    this.filterCars();
                });
            }
        }
    }

    openDetails() {
        const OPEN_DETAILS_BTNS = this.WRAPPER.querySelectorAll('.open-details');
        if (OPEN_DETAILS_BTNS.length > 0) {
            for (let i = 0; i < OPEN_DETAILS_BTNS.length; i++) {
                const BTN = OPEN_DETAILS_BTNS[i];
                const ID = BTN.getAttribute('data-car-id');
                const OPEN_TEXT = BTN.getAttribute('data-open-text');
                const CLOSE_TEXT = BTN.getAttribute('data-close-text');

                let data = {
                    'action': 'filter_car_variants',
                    'car_id': ID
                };

                BTN.addEventListener('click', () => {

                    // remove variants
                    const VARIANTS = this.WRAPPER.querySelectorAll('.cars-loop__variants');
                    if (VARIANTS.length > 0) {
                        for (let i = 0; i < VARIANTS.length; i++) {
                            VARIANTS[i].parentNode.removeChild(VARIANTS[i]);
                        }
                    }

                    // if button has already been clicked
                    if (BTN.innerHTML === CLOSE_TEXT) {
                        BTN.innerHTML = OPEN_TEXT;
                        return;
                    }

                    // reset buttons
                    if (OPEN_DETAILS_BTNS.length > 0) {
                        for (let i = 0; i < OPEN_DETAILS_BTNS.length; i++) {
                            OPEN_DETAILS_BTNS[i].innerHTML = OPEN_TEXT;
                        }
                    }

                    $.post(main_theme_objects.ajax_url, data, (response) => {

                        const PER_ROW = this.getPerRow();
                        const CAR_CARD = BTN.closest('.car-card');
                        const CARDS = this.WRAPPER.querySelectorAll('.car-card:not(.car-card--variant)');

                        // remove place-after classes
                        if (CARDS.length > 0) {
                            for (let i = 0; i < CARDS.length; i++) {
                                CARDS[i].classList.remove('place-after');
                            }
                        }

                        // add place-after classes
                        if (PER_ROW.elements !== null && PER_ROW.elements.length > 0) {
                            for (let i = 0; i < PER_ROW.elements.length; i++) {
                                PER_ROW.elements[i].classList.add('place-after');
                            }
                        } else if (CARDS.length === 2 && CAR_CARD === CARDS[0] && PER_ROW.per_row === 3) {
                            CAR_CARD.nextElementSibling.classList.add('place-after');
                        } else {
                            CAR_CARD.classList.add('place-after');
                        }

                        // get element to place markup after
                        const PLACE_AFTER_EL = this.getClosestSiblingWithClass(CAR_CARD, '.car-card.place-after');

                        if (response != 0 && PLACE_AFTER_EL) {
                            
                            let target_div = document.createElement('div');
                            target_div.innerHTML = response.markup;
                            target_div.classList.add('cars-loop__variants');
                            target_div.classList.add('show');

                            setTimeout(() => {
                                target_div.classList.add('animation');
                            }, 200);

                            this.insertAfter(target_div, PLACE_AFTER_EL);

                            new ObjectFitClass();

                            BTN.innerHTML = CLOSE_TEXT;
                            scrollToAnchor('#variants-group');

                        }
                    });
                });
            }
        }
    }

    getPerRow() {
        const SCREEN_WIDTH = this.getScreenWidth();
        if (SCREEN_WIDTH <= 800) {
            return {
                'per_row': 1,
                'elements': null
            };
        } else if (SCREEN_WIDTH <= 1250) {
            return {
                'per_row': 2,
                'elements': this.WRAPPER.querySelectorAll('.car-card:not(.car-card--variant):nth-of-type(2n)')
            };
        } else {
            return {
                'per_row': 3,
                'elements': this.WRAPPER.querySelectorAll('.car-card:not(.car-card--variant):nth-of-type(3n)')
            };
        }
    }

    filterCars() {

        this.showLoader();

        $.post(main_theme_objects.ajax_url, this.data, (response) => {
            if (response != 0) {

				if (this.CARS_WRAP) {
                    this.CARS_WRAP.innerHTML = response.markup;
                }
				
				if (this.PAGINATION_WRAP) {
					this.PAGINATION_WRAP.innerHTML = response.pagination;
                    this.initPagination();
                    this.openDetails();
				}
                
                // re-run objectfit
				new ObjectFitClass(); 

                // hide loader
                this.hideLoader();
                
                scrollToAnchor(this.SCROLL_TO_ID);
            }
		});
    }

    setUrl() {
		let parameters = '';
		if (parseInt(this.data.pagenumber) !== 1) {
			parameters = `?pagenumber=${this.data.pagenumber}`;
        }
		if (parameters == '') {
			parameters = this.data.url;
        }
		window.history.pushState('cars', '', parameters);
	}

    showLoader() {
		if (this.LOADER) this.LOADER.classList.add('loader--show');
	}

	hideLoader() {
		if (this.LOADER) this.LOADER.classList.remove('loader--show');
	}
    
    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    getClosestSiblingWithClass(elem, selector) {
        let sibling = elem.nextElementSibling;
        let class_name = '.' + elem.classList.value.replace(' ', '.');
        if (!selector) return sibling;
        if (!sibling) return elem;
        while (sibling) {
            if (class_name === selector) return elem;
            if (sibling.matches(selector)) return sibling;
		    sibling = sibling.nextElementSibling
        }
    }

    insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
}